module.exports = __webpack_public_path__ + "static/media/BF.c004fde8.svg";